"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _bfBaseStyles = require("@bestfit-team/bf-base-styles");
var _excluded = ["className", "large", "medium", "small", "gray", "pink", "teal", "darkTeal", "darkYellow", "darkOrange", "darkerTeal", "darkestTeal", "darkGrey", "white", "cream"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var baseCallout = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  font-weight: 700;\n  font-family: var(--bf-lead-font);\n  line-height: 105%;\n\n  color: var(--main-color);\n\n  /* colors */\n  &.gray {\n    --main-color: var(--bf-core-gray);\n  }\n  \n  &.pink {\n    --main-color: var(--bf-core-pink);\n  }\n\n  &.teal {\n    --main-color: var(--bf-core-teal);\n  }\n\n  &.darkTeal {\n    --main-color: var(--bf-core-dark-teal);\n  }\n\n  &.darkYellow {\n    --main-color: var(--bf-dark-yellow);\n  }\n\n  &.darkOrange {\n    --main-color: var(--bf-dark-orange);\n  }\n\n  &.darkerTeal {\n    --main-color: var(--bf-darker-teal);\n  }\n\n  &.darkestTeal {\n    --main-color: var(--bf-darkest-teal);\n  }\n\n  &.darkGrey {\n    --main-color: var(--bf-dark-grey);\n  }\n  \n  &.cream {\n    color: var(--main-color);\n  }\n"])));
var SmallCallout = (0, _styledComponents.default)(baseCallout)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  font-size: 60px;  \n\n  @media (min-width: ", ") {\n    font-size: 85px;  \n  }\n\n  @media (min-width: ", ") {\n    font-size: 90px;  \n  }\n  \n  @media (min-width: ", ") {\n    font-size: 100px;  \n  }\n  \n  @media (min-width: ", ") {\n    font-size: 110px;  \n  }\n"])), _bfBaseStyles.Breakpoints.s, _bfBaseStyles.Breakpoints.m, _bfBaseStyles.Breakpoints.xl, _bfBaseStyles.Breakpoints.xxl);
var MediumCallout = (0, _styledComponents.default)(baseCallout)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  font-size: 60px;  \n\n  @media (min-width: ", ") {\n    font-size: 110px;  \n  }\n\n  @media (min-width: ", ") {\n    font-size: 150px;  \n  }\n"])), _bfBaseStyles.Breakpoints.s, _bfBaseStyles.Breakpoints.m);
var LargeCallout = (0, _styledComponents.default)(baseCallout)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  font-size: 80px;  \n  @media (min-width: ", ") {\n    font-size: 200px;  \n  }\n\n  @media (min-width: ", ") {\n    font-size: 255px;  \n  }\n"])), _bfBaseStyles.Breakpoints.s, _bfBaseStyles.Breakpoints.m);
var Callout = function Callout(_ref) {
  var className = _ref.className,
    large = _ref.large,
    medium = _ref.medium,
    small = _ref.small,
    gray = _ref.gray,
    pink = _ref.pink,
    teal = _ref.teal,
    darkTeal = _ref.darkTeal,
    darkYellow = _ref.darkYellow,
    darkOrange = _ref.darkOrange,
    darkerTeal = _ref.darkerTeal,
    darkestTeal = _ref.darkestTeal,
    darkGrey = _ref.darkGrey,
    white = _ref.white,
    cream = _ref.cream,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var colorClassName = Object.entries({
    gray: gray,
    pink: pink,
    teal: teal,
    darkTeal: darkTeal,
    darkYellow: darkYellow,
    darkOrange: darkOrange,
    darkerTeal: darkerTeal,
    darkestTeal: darkestTeal,
    darkGrey: darkGrey,
    white: white
  }).find(function (_ref2) {
    var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
      select = _ref3[1];
    return select;
  });
  var calculatedClassNames = colorClassName ? "".concat(className, " ").concat(colorClassName[0]) : "".concat(className);
  if (small) return _react.default.createElement(SmallCallout, Object.assign({
    className: calculatedClassNames
  }, props));
  if (medium) return _react.default.createElement(MediumCallout, Object.assign({
    className: calculatedClassNames
  }, props));
  if (large) return _react.default.createElement(LargeCallout, Object.assign({
    className: calculatedClassNames
  }, props));
  return _react.default.createElement(SmallCallout, Object.assign({
    className: calculatedClassNames
  }, props));
};
var _default = Callout;
exports.default = _default;